module.exports = __webpack_public_path__ + "img/fixed-layout.8b818fa.svg";